module.exports = "/assets/fonts/Fredoka-Bold.ttf";